module.exports = __webpack_public_path__ + "static/media/take3Aces_1.b50b4af1.png";